export default __webpack_public_path__ + "static/media/image-5.0aa42b87.webp";